/* MCP connection list (A-0008.07). */
import {
    Button
} from 'shared/components/ui/button';

const MCPList = ({
    connections, loading, selectedId, onEdit, onDelete
}) => {
    if (loading) {
        return <p className="text-sm text-muted-foreground">Loading…</p>;
    }
    if (!connections || connections.length === 0) {
        return (
            <p className="text-sm text-muted-foreground">
                No MCP connections yet. Click "New" to create one.
            </p>
        );
    }
    return (
        <ul className="space-y-2">
            {connections.map((c) => (
                <li
                    key={c.connection_id}
                    className={`p-2 rounded border ${
                        selectedId === c.connection_id ? 'border-primary' : 'border-border'
                    }`}
                >
                    <div className="flex items-start justify-between gap-2">
                        <div className="min-w-0">
                            <p className="font-mono text-sm font-semibold truncate">
                                {c.connection_name}
                            </p>
                            <p className="text-xs text-muted-foreground truncate" title={c.server_url}>
                                {c.server_url}
                            </p>
                            {c.description && (
                                <p className="text-xs text-muted-foreground line-clamp-2">
                                    {c.description}
                                </p>
                            )}
                        </div>
                        <div className="flex flex-col gap-1 shrink-0">
                            <Button size="sm" variant="outline" onClick={() => onEdit(c)}>
                                Edit
                            </Button>
                            <Button size="sm" variant="ghost" onClick={() => onDelete(c)}>
                                Delete
                            </Button>
                        </div>
                    </div>
                </li>
            ))}
        </ul>
    );
};

export default MCPList;
